import { Quote } from "lucide-react";
import { Reveal } from "./Reveal";

const QUOTES = [
  {
    id: "testimonial-card-1",
    quote: "Antes pasaba los lunes llamando a clientes con vergüenza. Ahora YateAviso lo hace por mí y el 90% paga antes del vencimiento.",
    name: "Carmen Quispe",
    role: "Floristería Las Gardenias · Lima, Perú",
    img: "https://images.pexels.com/photos/5410081/pexels-photo-5410081.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "testimonial-card-2",
    quote: "Recuperé 14 horas a la semana. Las uso en mi cafetería, no persiguiendo pagos. El semáforo de riesgo es oro puro.",
    name: "Mariana Solano",
    role: "Café Bohemia · Ciudad de México",
    img: "https://images.pexels.com/photos/6684766/pexels-photo-6684766.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "testimonial-card-3",
    quote: "Mis clientes creen que les escribo yo personalmente. Cobré en 48 horas facturas que llevaban dos meses vencidas.",
    name: "Andrés Restrepo",
    role: "Taller Gráfico R2 · Medellín, Colombia",
    img: "https://images.unsplash.com/photo-1749353709877-8ce1be961500?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwzfHxoYXBweSUyMGJ1c2luZXNzJTIwb3duZXIlMjBwb3J0cmFpdCUyMHNtaWxpbmclMjBsYXRpbm98ZW58MHx8fHwxNzkwMDI5NjcwfDA&ixlib=rb-4.1.0&q=85",
  },
];

export const Testimonials = () => (
  <section data-testid="testimonials-section" className="border-y border-white/5 bg-[#131316]/40">
    <div className="mx-auto max-w-6xl px-4 py-24 sm:px-6 lg:py-32">
      <Reveal>
        <p className="mono mb-4 text-xs uppercase tracking-[0.2em] text-emerald-400">Historias reales</p>
        <h2 className="font-display max-w-2xl text-2xl font-bold leading-snug tracking-tight sm:text-3xl lg:text-4xl">
          Mypes que ya cobran sin pena.
        </h2>
      </Reveal>

      <div className="mt-14 grid gap-5 md:grid-cols-3">
        {QUOTES.map((q, i) => (
          <Reveal key={q.id} delay={i * 0.12} className="h-full">
            <figure
              data-testid={q.id}
              className="flex h-full flex-col rounded-3xl border border-white/10 bg-[#0A0A0C] p-7 transition-all duration-500 hover:-translate-y-1.5 hover:border-emerald-500/30"
            >
              <Quote className="h-6 w-6 text-orange-400" />
              <blockquote className="mt-5 flex-1 text-sm leading-relaxed text-slate-300">
                "{q.quote}"
              </blockquote>
              <figcaption className="mt-7 flex items-center gap-3 border-t border-white/10 pt-5">
                <img
                  src={q.img}
                  alt={q.name}
                  loading="lazy"
                  className="h-11 w-11 rounded-full border border-white/15 object-cover"
                />
                <div>
                  <p className="text-sm font-semibold">{q.name}</p>
                  <p className="mono text-[10px] uppercase tracking-wider text-slate-500">{q.role}</p>
                </div>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
